import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/PageContent";
import getToken from "app/api/getToken";

import { IPageContent } from "app/api/types";

export const EDIT_PAGE_CONTENT_REQUEST = "EDIT_PAGE_CONTENT_REQUEST";
export const EDIT_PAGE_CONTENT_SUCCESS = "EDIT_PAGE_CONTENT_SUCCESS";
export const EDIT_PAGE_CONTENT_FAIL = "EDIT_PAGE_CONTENT_FAIL";

export const editPageContent = (data: IPageContent) => (dispatch: any): any => {
  dispatch({ type: EDIT_PAGE_CONTENT_REQUEST });

  const token = getToken();

  return api
    .editPageContent(token, data)
    .then((response: AxiosResponse) => {
      const pageContent: IPageContent = get(response, "data", {});
      dispatch({ type: EDIT_PAGE_CONTENT_SUCCESS, payload: pageContent });

      return pageContent;
    })
    .catch(err => {
      dispatch({
        type: EDIT_PAGE_CONTENT_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
